export const TYPE_OPTIONS = [
  "text",
  "textarea",
  "radio",
  "checkbox",
  "select",
  "date",
  "file"
];

export const TYPES_WITH_OPTIONS = ["radio", "checkbox", "select"];
